import React, { useRef } from 'react'

import PropTypes from 'prop-types'
import { styled } from '@mui/material'
import StrapiLink from '@templates/strapi-cms/content-types/Link'
import StrapiImage from '@templates/strapi-cms/content-types/Image'

const ImgWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
  width: '100%',
  aspectRatio: '3/2',
  '& img': {
    borderRadius: '2px',
  },
}))

const boldnessMap = {
  Normal: 400,
  Medium: 500,
  SemiBold: 600,
  Bold: 700,
  ExtraBold: 800,
}

const TitleText = styled('div')(({ Boldness }) => ({
  fontSize: '14px',
  lineHeight: 'normal',
  marginTop: '5px',
  color: '#333',
  fontWeight: Boldness ? boldnessMap[Boldness] : 500,
  textAlign: 'left',
}))

const RightSideBanner = ({ bannerGroup = null, onClose }) => {
  const bannerRef = useRef()

  if (!bannerGroup) {
    return null
  }

  const banner = bannerGroup?.CategoryBanners?.[0]?.CategoryBanner
  const image = banner?.Image
  const link = banner?.CategoryLink?.Link
  return (
    <div>
      <StrapiLink
        data={{ ...link }}
        trackingData={{
          category: 'navigation',
          action: 'link click',
          label: link?.Title || link?.DisplayText,
        }}
        disableUnderline
        onClick={onClose}
      >
        <ImgWrapper>
          <StrapiImage
            data={{
              desktop: image,
              alt: link?.DisplayText,
            }}
            noPaddingBottom
          />
          <TitleText className="tile-title-text" Boldness={link?.Boldness}>
            {link?.DisplayText}
          </TitleText>
        </ImgWrapper>
      </StrapiLink>
    </div>
  )
}

RightSideBanner.propTypes = {
  bannerGroup: PropTypes.object,
  onClose: PropTypes.func.isRequired,
}

export default RightSideBanner
